import BDiaryDayEntry from "./BDiaryDayEntry";

export default class BDiaryDayEntries
{
	constructor(el)
	{
		this.el = el;
	}

	static selector = () => `.profile-entries`;

	static initialize()
	{
		this.addEventListeners();
	}

	static addEventListeners()
	{
		document.addEventListener("change", (event) => {
			if (event.target.matches(`.profile-entry__checkbox input`)) {
				let entries = new this(event.target.closest(`.profile-entries`));
				entries.refreshActions();
			}
		});
	}

	getCheckedEntries()
	{
		let res = [];
		this.el.querySelectorAll(`.profile-entry__checkbox input:checked`).forEach(el => {
			res.push(new BDiaryDayEntry(el.closest(BDiaryDayEntry.selector())));
		});

		return res;
	}

	getCheckedEntryIds()
	{
		let res = [];
		for (let entry of this.getCheckedEntries()) {
			res.push(entry.getObjectId());
		}

		return res;
	}

	getContainer()
	{
		return this.el.closest(`.profile-entries-container`);
	}

	showActions()
	{
		this.getContainer().querySelector(`.profile-entries-actions`).hidden = false;
	}

	hideActions()
	{
		this.getContainer().querySelector(`.profile-entries-actions`).hidden = true;
	}

	refreshActions()
	{
		this.getCheckedEntries().length ? this.showActions() : this.hideActions();
	}
}
